import React from "react";
import { Helmet } from "react-helmet";
import FormDocumentosAfiliadosV2 from "../../components/paet/FormDocumentosAfiliadosV2";

export default function FormaPagodos() {

    return (
        <div className="container home">
            <Helmet>
                <title>Retiro Enfermos Terminales AFP Modelo | Solicitud de Retiro Enfermos Terminales | AFP Modelo</title>
                <meta name="description" content={``} />
                <meta name="robots" content="noindex, follow" />
            </Helmet>
            <div>
                <section>
                    <div className="row w-100 container-padre calculadora">
                        <div className="row">
                            <div className="bloque form">
                                <div className="card formulario">
                                    <div className="card-title textoTitulo">Formulario de Retiro de Pensión Anticipada por Enfermedad Terminal</div>
                                    <span className="textoSecundario">Adjuntar certificados médicos del afiliado o pensionado</span>
                                    <div className="card-body">
                                        <span className="">En esta sección deberás adjuntar los certificados y autorización médica según corresponda.</span><br /><br />
                                        <FormDocumentosAfiliadosV2 />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </div>
    )
}